import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import '../CSS/style.css'
import '../CSS/responsive.css'
// import Search from './search'
// import QuesSolTemplate from './question_solution_template';
// import About from './about'
import mode from '../assets/mode.png'

// var query;
function NavBar(props) {
  
  const [searchText , setSearchText ] = useState("");
  const handleOnChange = (event) =>{
    setSearchText(event.target.value);
  }


  const handleHamClk = () =>{
    document.documentElement.querySelector("#options").classList.toggle("hidden");
    document.documentElement.querySelector("#search").classList.toggle("hidden");
    document.documentElement.querySelector('#hamburger').classList.toggle("hidden");
    document.documentElement.querySelector("#cross").classList.toggle("hiddencross");
  }

  const handleModeChange = () =>{
    document.documentElement.querySelector('body').classList.toggle("dark");
  }
  return (
    <>
    <div className="navbar">
      <div className="resp">
        {/* Logo */}
        <div className="logo"><Link to="/">{props.title}</Link></div>
        
        {/* HamBurger Icon */}
        <div className="hamburger" id="hamburger" onClick={handleHamClk}>
          <div className="line1"></div>
          <div className="line2"></div>
          <div className="line3"></div>
        </div>
        <div className="cross hiddencross" id='cross' onClick={handleHamClk}>&#10060;</div>
        </div>
        <div  id='search' className='search hidden'>
          <input type="text" name="query" id="query" onChange={handleOnChange}  placeholder='Search Here...' value={searchText} />
<button className='button' id='querybutton' >Search</button>
        </div>
        
        <div className="options hidden" id='options'>
        
            <ul>
            <div className="chngMode" onClick={handleModeChange}>
         <img className='mode' src={mode} alt="ModeChange" />
        </div>
                <li><Link to="/">Home</Link></li>
                <li><Link to="/about">About</Link></li>
                <li><Link to="/teams">Team</Link></li>
                <li><Link to="/codes">Codes</Link></li>
                <li><Link to="/">Blog</Link></li>
                <li><Link to="/contact" id='contactus'>Contact Us</Link></li>
            </ul>
        </div>
        
       
        {/* <div className="button">
            <button className='login'>Contact Us</button>
            {/* <button className='signup'>SignUp</button> 
            </div> 
        */}
        </div>
    
   

    </>
  
    )
    
    
}
export default NavBar;
